
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import LazyImg from '@xt/www/components/lazyImg/index.vue'
import { Observer } from 'mobx-vue'

@Observer
@Component({
  components: {
    LazyImg
  }
})
export default class BigBgImg extends Vue {
  @Prop({ default: 1920 }) readonly width!: number
  @Prop({ required: true }) readonly height!: number
  @Prop({ default: 20 }) readonly length!: number
  @Prop({ required: true }) readonly path!: string
  @Prop({ required: true }) readonly picPrefix!: string
  @Prop({ default: 'png' }) readonly picType!: string

  get bgStyle() {
    return {
      width: `${this.width}px`,
      height: `${this.height}px`
    }
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
